<template>
    <section class="page-panel">
        <ui-header :sidebar="false" />
        <section class="body">
            <section v-if="isSidebarLeft" class="sidebar-left" :class="{ 'active': sidebarLeft }" :style="{ 'background': backgroundColor }">
                <slot name="sidebar-left" />
            </section>
            <section v-if='load' class="load-page-init">
                <ui-load-indicator :h="70" :stroke="8" bg-color="#DFE5EC" color="#69D296" />
            </section>
            <section class="content">
                <ui-breadcrumbs design="full" :container="false">
                    <template #left>
                        <span>{{ title }}</span>
                        <span>&#8226; {{ moduleName }} </span>
                        <span v-if="subtitle"> &#8226; {{ subtitle }} </span>
                    </template>
                </ui-breadcrumbs>

                <section class="header">
                    <div v-if="isSidebarLeft" class="control-sidebar-left">
                        <button type="button" class="btn-toggle-sidebar" @click="toogleSidebarLeft">
                            <i class="far" :class="sidebarLeft ? 'fa-chevron-left' : 'fa-chevron-right'"/>
                        </button>
                    </div>
                    <div v-if="headerTitle" class="title" :class="{ 'active-header': activeHeader }">
                        <div v-if="activeHeader">
                            <h2>{{ moduleName }}<span v-if="subtitle"> - {{ subtitle }}</span></h2>
                            <p>{{ description }}</p>
                        </div>

                        <div v-if="activeHeader">
                            <ui-search-box placeholder="Buscar Empreendimento" event="set-search-enterprise"/>
                        </div>

                        <div v-if="activeHeader">
                            <ui-menu-card icon="fal fa-cog" icon-size="20">
                                <a type="button" href="/empreendimentos/etapa1">Cadastrar Empreendimento</a>
                                <a type="button" href="/empreendimentos/categorias">Gerenciar Categorias</a>
                            </ui-menu-card>
                        </div>

                        <div v-if="headerActions" class="header-actions">
                            <slot name="header-actions" />
                        </div>
                    </div>
                    <div v-if="isSidebarRight" class="control-sidebar-right">
                        <button type="button" class="btn-toggle-sidebar" @click="toogleSidebarRight">
                            <i class="far" :class="sidebarRight ? 'fa-chevron-right' : 'fa-chevron-left'"/>
                        </button>
                    </div>
                </section>
                <section
                    ref="productsToTop"
                    v-scroll-paginate="next"
                    class="scroll-color"
                    :class="widthAuto ? 'auto' : 'page'"
                >
                    <div v-if="loadProduct" class="load-page-product">
                        <ui-load-indicator :h="70" :stroke="8" bg-color="#DFE5EC" color="#69D296" />
                    </div>

                    <ui-page-message
                        v-if="existsProducts"
                        class="no-products"
                        icon="fal fa-exclamation-triangle"
                        icon-size="60"
                        :bg="true"
                        text="Não foi possível encontrar nenhum empreendimento!"
                    />

                    <div class="slot-page" :class="{'slot-page-list': slotPageList}">
                        <slot name="page" />
                    </div>

                    <section v-if="isSidebarBottom" class="sidebar-bottom" :class="{ 'active': sidebarBottom }">
                        <div class="control-sidebar-bottom">
                            <button type="button" class="btn-toggle-sidebar" @click="toogleSidebarBottom">
                                <i class="far" :class="sidebarBottom ? 'fa-chevron-down' : 'fa-chevron-up'"/>
                            </button>
                        </div>

                        <slot name="sidebar-bottom" />
                    </section>
                </section>
            </section>
            <section v-if="isSidebarRight" class="sidebar-right" :class="{ 'active': sidebarRight }">
                <slot name="sidebar-right" />
            </section>
        </section>
        <ui-active-offer-modal />
        <uiRatingNPS />
        <ui-feedback-modal />
        <ui-thank-feedback-modal />
    </section>
</template>

<script>
	import uiHeader from '@/components/ui/panel-header'
	import uiMenuCard from '@/components/ui/menu-card'
	import uiPageMessage from "@/components/ui/page-message"
	import { uiBreadcrumbs, uiSearchBox } from "@/components/ui"
	import { uiActiveOfferModal } from '@/components/ui-facilita/active-offer'
	import uiFeedbackModal from '@/components/ui-facilita/modals/feedback-modal'
	import uiThankFeedbackModal from '@/components/ui-facilita/modals/feedback-modal/thank-feedback-modal'
	import { scrollPaginate} from '@/directives'
	import { mapGetters } from 'vuex'
	import { uiLoadIndicator } from '@/components/ui'
	import { storage } from '@/services/storage'

	import uiRatingNPS from '@/components/ui-facilita/rating/nps/index.vue'

	export default {
		name: 'ui-page-products',
		components: { uiHeader, uiActiveOfferModal, uiBreadcrumbs, uiSearchBox, uiMenuCard, uiLoadIndicator, uiPageMessage, uiRatingNPS, uiFeedbackModal, uiThankFeedbackModal },

		directives: {
			scrollPaginate
		},

		props:{
			loadProduct: {
				type: Boolean,
				default: false
			},
			load: {
				type: Boolean,
				default: false
			},
			existsProducts: {
				type: Boolean,
				default: false
			},
			moduleName: {
				type: String,
				required: false,
				default: ''
			},
			title: {
				type: String,
				required: false,
				default: ''
			},
			subtitle: {
				type: String,
				required: false,
				default: ''
			},
			description: {
				type: String,
				required: false,
				default: ''
			},
			activeHeader: {
				type: Boolean,
				default: true
			},
			backgroundColor: {
				type: String,
				default: '#fbfbff'
			},
			widthAuto: {
				type: Boolean,
				default: false
			},
			headerTitle: {
				type: Boolean,
				default: true
			},
			slotPageList: {
				type: Boolean,
				default: false
			},
			/**
			 * Define se será mostrado um slot para inserir opões e components customizados
			 * no header
			 * Obs.: Só funciona se o headerTitle também for true e o slot é "header-actions"
			 */
			headerActions: {
				type: Boolean,
				required: false,
				default: false
			}
		},

		data(){
			return {
				sidebarLeft: true,
				sidebarRight: true,
				sidebarBottom: true,
				auto: null
			}
		},

		computed: {
			...mapGetters('auth', {
				user: 'getUser',
			}),
			isSidebarLeft(){
				return this.$slots['sidebar-left'] ? true : false
			},
			isSidebarRight(){
				return this.$slots['sidebar-right'] ? true : false
			},
			isSidebarBottom() {
				return this.$slots['sidebar-bottom'] ? true : false
			}
		},

		beforeMount() {
			this.$nextTick(() => {
				const companiesRestricted = this.$store.getters.companiesRestricted
				let user = JSON.parse(storage.get('user_logged'))
				let config = JSON.parse(storage.get('api_config'))

				window.dataLayer[0].user 				 = user
				window.dataLayer[0].configs 			 = JSON.parse(storage.get('get-configs-data'))
				window.dataLayer[0].companies_restricted = companiesRestricted
				window.dataLayer[0].instance_user_id 	 = config.instance + '_' + user.id
				window.dataLayer[0].instance 	 		 = config.instance
			})
		},
		beforeDestroy() {
			this.$root.$off('scroll-to-top')
		},

		mounted() {
			this.$root.$on('scroll-to-top', () => {
				this.$refs.productsToTop.scrollTop = 0
			})
		},
		methods: {
			next() {
				this.$emit('new-content')
			},
			toogleSidebarLeft(){
				this.sidebarLeft = !this.sidebarLeft
			},
			toogleSidebarRight(){
				this.sidebarRight = !this.sidebarRight
			},
			toogleSidebarBottom() {
				this.sidebarBottom = !this.sidebarBottom
			}
		}
	};
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>

